// extracted by mini-css-extract-plugin
module.exports = {"typing-loader":"TypingLoader_typing-loader__KBm3g","typing-loader__dot":"TypingLoader_typing-loader__dot__1lHoX","wave":"TypingLoader_wave__YUqlF"};